import moment, { Moment } from "moment"

const isInvalidStartDate = (startDate: Moment) => {
  return moment().isAfter(startDate, "day")
}

export default isInvalidStartDate
